import React, { ReactNode, useState } from 'react';
import { styled } from 'styled-components';

import Text from 'components/common/Text';
import Divider from 'components/Divider';
import DropdownForm from './DropdownForm';
import { ModifyValue } from '../../hooks/useProductDetaillHooks';
import { ProductParamInput } from 'containers/ProductRegist/hooks/types';
import { InquiryTemplate, ProductKind } from 'types/api';
import { isEmpty } from 'lodash';
import Row from 'components/common/Row';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  padding: 40px 20px;
  width: 100%;
`;

interface Props {
  productParamInput: ProductParamInput;
  modifyValue: ModifyValue;
  inquiryList: InquiryTemplate;
  setModifyValue: React.Dispatch<React.SetStateAction<ModifyValue>>;
}

const PcViewForm = (props: Props) => {
  const { productParamInput, modifyValue, inquiryList, setModifyValue } = props;

  const isOffline = productParamInput.kind === ProductKind.OFFLINE;
  const fripInfo = productParamInput.frip;
  const isEmptyAdditional =
    isEmpty(fripInfo.exclusions) &&
    isEmpty(fripInfo.inclusions) &&
    isEmpty(fripInfo.stuffsToPrepare);

  const BASIC_INFO_LIST = [
    {
      title: '사진',
      value: 'image',
    },
    { title: '상품명', value: 'title' },
    { title: '소개글', value: 'introduce' },
    {
      title: isOffline ? '장소' : '온라인 진행방법',
      value: isOffline ? 'address' : 'online',
    },
    { title: '프로필', value: 'profile' },
    { title: '유의사항', value: 'precaution' },
    { title: '환불정책', value: 'refund' },
  ];

  const ADDITIONAL_INFO_LIST = [
    {
      title: '스케줄',
      value: 'schedule',
      isAccept: !isEmpty(fripInfo.curriculum.sections),
    },
    { title: '질문', value: 'question', isAccept: !isEmpty(inquiryList) },
    { title: '부가 정보', value: 'moreInformation', isAccept: true },
    { title: '추가 정보', value: 'additional', isAccept: !isEmptyAdditional },
  ];

  const OPTION_SCHEDULE_LIST = [
    { title: '옵션', value: 'option', visible: true },
    { title: '일정', value: 'calendar', visible: fripInfo.attachedToSchedule },
    { title: '판매기간', value: 'saleTerm', visible: true },
    {
      title: '1인당 재주문 한도',
      value: 'onceLimit',
      visible: productParamInput.grossPurchaseLimitation !== null,
    },
  ];

  const handleSetModifyValue = (value: string) => {
    if (value === '') {
      return;
    }

    if (value === 'address') {
      if (isOffline) {
        setModifyValue({ ...modifyValue, modifyStatus: value });

        return;
      }

      setModifyValue({ ...modifyValue, modifyStatus: 'online' });

      return;
    }

    setModifyValue({ ...modifyValue, modifyStatus: value });
  };

  return (
    <Container>
      <DropdownForm title="상품 정보" isRequired="Y">
        {BASIC_INFO_LIST.map(item => (
          <Text
            key={item.value}
            size="16px"
            color={
              item.value === modifyValue.modifyStatus
                ? '#0071E9'
                : item.value === 'precaution' || item.value === 'refund'
                ? '#989BA2'
                : '#46474C'
            }
            style={{ cursor: 'pointer' }}
            onClick={() => handleSetModifyValue(item.value)}
          >
            {item.title}
          </Text>
        ))}
      </DropdownForm>
      <Divider />
      <DropdownForm title="추가 정보" isRequired="N">
        {ADDITIONAL_INFO_LIST.map(item => (
          <Row gap="8px" key={item.value}>
            <Text
              size="16px"
              color={
                item.value === modifyValue.modifyStatus ? '#0071E9' : '#46474C'
              }
              style={{ cursor: 'pointer' }}
              onClick={() => handleSetModifyValue(item.value)}
            >
              {item.title}
            </Text>
            {!item.isAccept && (
              <Text
                size="12px"
                weight={600}
                color="#989BA2"
                // color={item.isAccept ? '#0071E9' : '#989BA2'}
              >
                미등록
                {/* {item.isAccept ? '등록' : '미등록'} */}
              </Text>
            )}
          </Row>
        ))}
      </DropdownForm>
      <Divider />
      <DropdownForm title="옵션 • 일정">
        {OPTION_SCHEDULE_LIST.map(
          item =>
            item.visible && (
              <Text
                key={item.value}
                size="16px"
                color={
                  item.value === modifyValue.modifyStatus
                    ? '#0071E9'
                    : '#46474C'
                }
                style={{ cursor: 'pointer' }}
                onClick={() => handleSetModifyValue(item.value)}
              >
                {item.title}
              </Text>
            ),
        )}
      </DropdownForm>
    </Container>
  );
};

export default PcViewForm;
